import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetSelfServiceFlowSection} from '../hooks/useGetSelfServiceFlow';
import {LoadingPlaceholder} from './LoadingPlaceholder';
import {SelfServiceFlowSectionView} from './SelfServiceFlowSectionView';

export const SelfServiceFlowSection = ({
  noDescription,
}: {
  noDescription?: boolean;
}) => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowSection()}
      View={SelfServiceFlowSectionView}
      viewProps={{noDescription}}
      Error={() => null}
      Loading={LoadingPlaceholder}
    />
  );
};
